/**
 * フローティングCTA関連
 */
export default class Floating {
  constructor() {
    this.scrollEvent();
    this.isHidden();
  };

  /**
   * スクロールイベント
   */
  scrollEvent() {
    window.addEventListener('scroll', this.isHidden);
  };

  /**
   * フッターに被った時に非表示にする
   */
  isHidden() {
    const $footerPosi = $('.l-footer').offset();
    const $scroll = $(window).scrollTop();
    const $windowH = $(window).innerHeight();
    const $envetPosi = $scroll + $windowH;
    if ( $envetPosi >= $footerPosi.top ) {
      $('#js-floating').addClass('is-hidden');
    } else {
      $('#js-floating').removeClass('is-hidden');
    }
  }
}
